import { SimpleWarehouse } from "common/clients/warehouse/Warehouse/SimpleWarehouse";

export const getWarehouseAddressLabel = (warehouse?: SimpleWarehouse) =>
  warehouse ? `${warehouse.address.city}, ${warehouse.address.state}` : "";
